export const GET_SUPERUSERS= 'GET_SUPERUSERS'
export const GET_SUPERUSERS_SUCCESS= 'GET_SUPERUSERS_SUCCESS'
export const GET_SUPERUSERS_ERROR='GET_SUPERUSERS_ERROR'

export const GetSuperUsers= (data) => ({
    type: GET_SUPERUSERS,
    payload: data
})